import React from "react";

interface IconProps {
  className?: string;
  strokeWidth?: number;
}

const ErrorIcon: React.FC<IconProps> = ({ 
  className = "h-8 w-8 text-red-600", 
  strokeWidth = 2.5 
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={strokeWidth}
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
    </svg>
  );
};

export default ErrorIcon;